import React from 'react';
import { WidgetSize } from '../widget.types';
import { InventoryWidgetXS } from './InventoryWidgetXS/InventoryWidgetXS';
import { InventoryWidgetS } from './InventoryWidgetS/InventoryWidgetS';
import { configureModalMap } from '@topconagriculture/modal';
import { inventoryLargeModalName } from './InventoryWidgetConfig';
import { WidgetFooter } from '../common/WidgetFooter';
import { InventoryWidgetLModal } from './InventoryWidgetL/InventoryWidgetTable/modal/InventoryWidgetLModal';
import { InventoryWidgetL } from './InventoryWidgetL/InventoryWidgetL';
import { useInventorySubscription } from './useInventorySubscription';
import { getInventoryParams } from '../../../utils/utils';
const inventorySizeMap = {
    [WidgetSize.XS]: InventoryWidgetXS,
    [WidgetSize.S]: InventoryWidgetS,
    [WidgetSize.L]: InventoryWidgetL,
};
configureModalMap({
    [inventoryLargeModalName]: React.createElement(InventoryWidgetLModal, null),
});
export const InventoryWidget = ({ widget }) => {
    var _a;
    const Component = inventorySizeMap[((_a = widget.config) === null || _a === void 0 ? void 0 : _a.size) || WidgetSize.XS];
    const inventory = useInventorySubscription();
    const { viewMoreButtonIsDisabled, includedIngredients } = getInventoryParams(inventory);
    const link = `/inventory/overview?ingredients=${includedIngredients}`;
    return (React.createElement(React.Fragment, null,
        Component ? React.createElement(Component, { widget: widget }) : null,
        React.createElement(WidgetFooter, { link: link, viewMoreButtonIsDisabled: viewMoreButtonIsDisabled })));
};
//# sourceMappingURL=InventoryWidget.js.map